// extracted by mini-css-extract-plugin
export default {"container":"do-z","ratingLayout":"eo-z","ratingLabel":"fo-z","nonInteractiveRatingLabel":"go-z"};